import { isDefined } from "@clipboard-health/util-ts";
import { Box } from "@mui/material";
import { type Location } from "@src/appV2/redesign/utils/routes";
import { startTransition } from "react";
import { useHistory } from "react-router-dom";

import { Badge } from "../../../../components/Badge";
import { Icon, type IconType } from "../../../../components/Icon";
import { applyPlatformAwareInteractionStyles } from "../../../../utils/applyPlatformAwareInteractionStyles";

interface NavigationMenuItemTabletProps {
  iconType: IconType;
  isSelected: boolean;
  routeTo?: Location;
  onClick?: () => void;
  badgeCount?: number;
}

export function NavigationMenuItemTablet(props: NavigationMenuItemTabletProps) {
  const { iconType, isSelected, routeTo, onClick, badgeCount } = props;

  const history = useHistory();

  const iconElement = (
    <Icon
      type={iconType}
      size="large"
      sx={{
        color: "inherit",
        flexShrink: 0,
      }}
    />
  );

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
        borderRadius: theme.borderRadius?.medium,
        cursor: "pointer",
        transition: theme.transitions.create(["background-color"], {
          duration: theme.transitions.duration.short,
        }),

        color: isSelected
          ? theme.palette.navbar?.itemContentSelected
          : theme.palette.navbar?.itemContent,

        backgroundColor: isSelected ? theme.palette.navbar?.itemSelectedBackground : "transparent",

        ...applyPlatformAwareInteractionStyles({
          hoverStyle: {
            backgroundColor: theme.palette.navbar?.itemSelectedBackground,
            color: theme.palette.navbar?.itemContentSelected,
          },

          defaultStyle: {
            backgroundColor: isSelected
              ? theme.palette.navbar?.itemSelectedBackground
              : "transparent",

            color: isSelected
              ? theme.palette.navbar?.itemContentSelected
              : theme.palette.navbar?.itemContent,
          },
        }),
      })}
      onClick={() => {
        startTransition(() => {
          if (isDefined(routeTo)) {
            history.push(routeTo);
          }

          onClick?.();
        });
      }}
    >
      {isDefined(badgeCount) && badgeCount > 0 ? (
        <Badge count={badgeCount} max={99} size="small">
          {iconElement}
        </Badge>
      ) : (
        iconElement
      )}
    </Box>
  );
}
